import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { Image } from '../common';
import etchedPitaEmpty from '../../assets/gifs/ETCH_PITA_EMPTY.gif';
import './InteractivePita.scss';

const InteractivePitaTemplate = (props) => {
  const { illustrations } = props;
  const {
    etchedPitaCheese,
    etchedPitaLettuce,
    etchedPitaLime,
    etchedPitaTomato,
  } = illustrations;
  return (
    <div className="interactive-pita">
      <div className="draggable">
        <div className="illustration illustration-pita-cheese">
          <Image
            image={{ localFile: etchedPitaCheese }}
            className="contain"
          />
        </div>
        <div className="illustration illustration-pita-lettuce">
          <Image
            image={{ localFile: etchedPitaLettuce }}
            className="contain"
          />
        </div>
        <div className="illustration illustration-pita-lime">
          <Image
            image={{ localFile: etchedPitaLime }}
            className="contain"
          />
        </div>
        <div className="illustration illustration-pita-tomato">
          <Image
            image={{ localFile: etchedPitaTomato }}
            className="contain"
          />
        </div>
      </div>
      <div className="illustration illustration-empty-pita">
        <img src={etchedPitaEmpty} alt="An empty pita" />
      </div>
    </div>
  );
};

const InteractivePita = props => (
  <StaticQuery
    query={graphql`
      query {
        etchedPitaCheese: file(relativePath: { eq: "assets/images/etched/ETCH_PITA_CHEESE.PNG" }) {
          childImageSharp {
            fluid(maxWidth: 1000 quality: 100) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
        etchedPitaLettuce: file(relativePath: { eq: "assets/images/etched/ETCH_PITA_LETTUCE.PNG" }) {
          childImageSharp {
            fluid(maxWidth: 1000 quality: 100) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
        etchedPitaLime: file(relativePath: { eq: "assets/images/etched/ETCH_PITA_LIME.PNG" }) {
          childImageSharp {
            fluid(maxWidth: 1000 quality: 100) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
        etchedPitaTomato: file(relativePath: { eq: "assets/images/etched/ETCH_PITA_TOMATO.PNG" }) {
          childImageSharp {
            fluid(maxWidth: 1000 quality: 100) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
      }
    `}
    render={data => <InteractivePitaTemplate illustrations={data} {...props} />}
  />
);

export default InteractivePita;
